export var Environments;
(function (Environments) {
    Environments["LOCAL"] = "local";
    Environments["LOCAL_K8S"] = "local_k8s";
    Environments["LOCAL_E2E"] = "local_e2e";
    Environments["SANDBOX"] = "sandbox";
    Environments["DEVELOPMENT"] = "development";
    Environments["STAGING"] = "staging";
    Environments["PRODUCTION"] = "production";
    Environments["TEST"] = "test";
})(Environments || (Environments = {}));
//# sourceMappingURL=generalEnums.js.map